// extracted by mini-css-extract-plugin
export var apiV2Alerts = "api-v2-alerts_XDYVtVK3FjnFNe8OZOHZ";
export var apiV2AlertsTable = "api-v2-alerts__table_IYR3rqBz2aZNSPBiLxnu";
export var apiV2AlertsTableCell = "api-v2-alerts__table-cell_ToR7rK2QKpGfiH4YefdK";
export var apiV2AlertsTableRow = "api-v2-alerts__table-row_r5dHv0XheUozMuz9q15R";
export var apiV2AlertsUnavailableMessage = "api-v2-alerts__unavailable-message_Ay4wzlGnXpRGwyqKvMHw";